import {SCondition, RequestQueryBuilder, QuerySortOperator} from '@nestjsx/crud-request';
import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {Observable} from 'rxjs';
import {SmartPrediction} from '../models/smart-prediction.entity';
import {map} from 'rxjs/operators';
import {PaginationResponse} from '../../../responses/pagination.response';
import {SmartPredictionsResponse} from '../responses';

@Injectable({
  providedIn: 'root'
})
export class TorchSmartTimesService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public getAllSmartTimes(pageSize: number = 15,
                          currentPage: number = 0,
                          sortDirection: string,
                          sortBy: string = 'companyPartNumber',
                          filters: SCondition): Observable<SmartPredictionsResponse> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection) {
      qb.sortBy({field: sortBy, order: sortDirection as QuerySortOperator});
    }

    if (!!filters) {
      qb.search(filters);
    }

    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/smart-predictions')
      .appendRawQueryString(qb.query(false));


    return this.httpClient.get<PaginationResponse>(endpoint.get).pipe(
      map(response => (response.data ? new SmartPredictionsResponse(response.data, response.total) : null))
    );
  }

  public getFleetModelCodes(forACN: string = null): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/smart-predictions')
      .addSegment('/fleet')
      .addQuery('forACN', forACN)
      .get;

    return this.httpClient.get<[{ fleetModelCode: string }]>(endpoint).pipe(
      map(response => response.map(v => v.fleetModelCode))
    );
  }

  public getRecentTailNumbers(contains: string = null, fleet: string = null): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/smart-predictions')
      .addSegment('/tailNumbers')
      .addQuery('contains', contains)
      .addQuery('fleet', fleet)
      .get;

    return this.httpClient.get<[{ aircraftNumber: string }]>(endpoint).pipe(
      map(response => response.map(v => v.aircraftNumber))
    );
  }

  public exportToExcel(predictions: SmartPrediction[]) {
    return new Observable(subscriber => {
      const endpoint = Burly(this.config.rootUrl)
        .addSegment('/smart-predictions')
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType } = {
        headers: new HttpHeaders({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {
        predictions
      };

      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });
  }

}
